<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded01">
<a id="page05"></a>
<p class="dedicationTextCenter"><em class="italic">This book is dedicated to my dear Óli.</em></p>
<p class="dedicationTextCenter"><em class="italic">Special thanks to Harald Schmitt,<br/> who lent me his name—<br/> and allowed me to kill him.</em></p>
<p class="dedicationAuthor"><em class="italic">–Yrsa</em></p>
<a id="page06"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded01.vue?39119882